export enum eAdjustmentType {
  TitlePremiumAdjustment = 'title_premium_adjustment',
}
